import { type AnyBlockType } from '../base/baseSchema.js';

export enum FlowDefinitionBlockTypeCompatibility {
  /**
   * Examples: Start block, Output block
   */
  Required = 'Required',
  /**
   * Examples: Script block, LLM block
   */
  Allowed = 'Allowed',
  /**
   * Some blocks have configs that can be used in flows only under certain conditions.
   * Examples:
   * - REST block using public APIs without authentication are allowed and commonly used in Skills.
   * - Human Task block with no categoryId is allowed.
   */
  ConditionallyAllowedBasedOnConfig = 'ConditionallyAllowedBasedOnConfig',
  /**
   * Some blocks are retired and can only be used in flows under certain conditions.
   * Examples:
   * - Legacy block types may still be supported for existing flows.
   * - Retired block types may be allowed only during migration or backward-compatibility scenarios.
   */
  ConditionallyAllowedRetiredBlock = 'ConditionallyAllowedRetiredBlock',
  /**
   * Some blocks are not cross organization compatible and thus cannot be used in flows.
   * Examples:
   * - For Skills, SubFlow block can have any block inside it, and therefore cannot guarantee cross-organization compatibility.
   * - GetNotableObject block relies on organization-specific Notable Object definitions.
   */
  NotAllowed = 'NotAllowed',
}

export type FlowDefinitionBlockCompatibilityByBlockType = Record<
  AnyBlockType,
  FlowDefinitionBlockTypeCompatibility
>;
